import * as React from "react";
const ChatIcon = (props: any) => (
  <svg
    width="current"
    height="current"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1319_27154"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <rect width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1319_27154)">
      <path
        d="M6.03845 17.5L4.03655 19.5019C3.75193 19.7865 3.42469 19.8509 3.05483 19.6951C2.68494 19.5394 2.5 19.2589 2.5 18.8538V4.30773C2.5 3.8026 2.675 3.37503 3.025 3.02503C3.375 2.67503 3.80257 2.50003 4.3077 2.50003H19.6923C20.1974 2.50003 20.625 2.67503 20.975 3.02503C21.325 3.37503 21.5 3.8026 21.5 4.30773V15.6923C21.5 16.1974 21.325 16.625 20.975 16.975C20.625 17.325 20.1974 17.5 19.6923 17.5H6.03845ZM5.4 16H19.6923C19.7692 16 19.8397 15.968 19.9038 15.9039C19.9679 15.8397 20 15.7692 20 15.6923V4.30773C20 4.2308 19.9679 4.16027 19.9038 4.09616C19.8397 4.03206 19.7692 4.00001 19.6923 4.00001H4.3077C4.23077 4.00001 4.16024 4.03206 4.09613 4.09616C4.03203 4.16027 3.99998 4.2308 3.99998 4.30773V17.3846L5.4 16ZM6.99998 13.75H13C13.2128 13.75 13.391 13.6782 13.5346 13.5346C13.6782 13.391 13.75 13.2128 13.75 13C13.75 12.7872 13.6782 12.609 13.5346 12.4654C13.391 12.3218 13.2128 12.25 13 12.25H6.99998C6.78716 12.25 6.60896 12.3218 6.46538 12.4654C6.32179 12.609 6.25 12.7872 6.25 13C6.25 13.2128 6.32179 13.391 6.46538 13.5346C6.60896 13.6782 6.78716 13.75 6.99998 13.75ZM6.99998 10.75H17C17.2128 10.75 17.391 10.6782 17.5346 10.5346C17.6782 10.391 17.75 10.2128 17.75 10C17.75 9.78719 17.6782 9.60899 17.5346 9.46541C17.391 9.32182 17.2128 9.25003 17 9.25003H6.99998C6.78716 9.25003 6.60896 9.32182 6.46538 9.46541C6.32179 9.60899 6.25 9.78719 6.25 10C6.25 10.2128 6.32179 10.391 6.46538 10.5346C6.60896 10.6782 6.78716 10.75 6.99998 10.75ZM6.99998 7.74998H17C17.2128 7.74998 17.391 7.67819 17.5346 7.53461C17.6782 7.39102 17.75 7.21282 17.75 7.00001C17.75 6.78719 17.6782 6.60899 17.5346 6.46541C17.391 6.32182 17.2128 6.25003 17 6.25003H6.99998C6.78716 6.25003 6.60896 6.32182 6.46538 6.46541C6.32179 6.60899 6.25 6.78719 6.25 7.00001C6.25 7.21282 6.32179 7.39102 6.46538 7.53461C6.60896 7.67819 6.78716 7.74998 6.99998 7.74998Z"
        fill="current"
      />
    </g>
  </svg>
);
export default ChatIcon;
